angular
    .module('empower.control')
    .directive('enterKey', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.enterKey);
                    });

                    event.preventDefault();
                }
            });
        };
    })
    .directive('autoSearch', function () {
        var keyupTimeout;

        return {
            require: 'ngModel',
            scope:{
                ngModel: '=ngModel',
                autoSearch: '&autoSearch'
            },
            link: function (scope, element, attrs, ctrl) {
                element.bind("keydown keypress", function (event) {
                    if (event.which === 13) {
                        clearTimeout(keyupTimeout);
                    }
                });

                ctrl.$parsers.unshift(function (viewValue) {                   
                    scope.ngModel = viewValue;
                    if (scope.ngModel == undefined) {
                        clearTimeout(keyupTimeout);
                        return viewValue;
                    }
                    var inputLength = scope.ngModel.length;
                    if (inputLength < 3 && inputLength > 0) {
                        clearTimeout(keyupTimeout);
                        return viewValue;
                    }

                    clearTimeout(keyupTimeout);
                    keyupTimeout = setTimeout(function () {
                        scope.$apply(function () {
                            scope.$eval(scope.autoSearch);
                        });
                    }, 1500);
                    return viewValue;
                });
            }
        };
    });
